import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null,
  asyncs: {
  }
}, 'ldInPutAway');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Document', field: 'Document', minWidth: 150 },
    { headerName: 'Committed', field: 'CommittedQuantityDisplay', type: 'numericColumn' },
    { headerName: 'User ID', field: 'UserId', type: 'numericColumn' },
    { headerName: 'Status', field: 'Status' },
    { headerName: 'Account', field: 'Account' }
  ],
  Data: [
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }

    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesOrderEnquiry.ldInPutAway,
  {
    Data: data => data.Data,
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.salesOrderEnquiry.ldInPutAway.loading,
  gridOptions: state => state.salesOrderEnquiry.ldInPutAway.data.gridOptions,
  Columns: state => state.salesOrderEnquiry.ldInPutAway.data.Columns,
  Actions: state => state.salesOrderEnquiry.ldInPutAway.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)